module.exports = __webpack_public_path__ + "static/media/boat-img-33.fbeab076.jpg";